import styled from 'styled-components'
import Icon from '@mdi/react'
import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'
import { Mark } from 'components/Mark'
import { Font14, Font16 } from 'components/Typography'

export const BreadcrumbsDesktopContainer = styled.div`
  display: none;
  @media ${theme.devices.tabletLandscape} {
    display: flex;
    height: 24px;
    margin: 16px 24px;
  }
`

export const BreadcrumbTitle = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const BreadcrumbsMobileContainer = styled(WhiteBlock)`
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  margin: 16px 0;
  @media ${theme.devices.tabletLandscape} {
    display: none;
  }
`

export const BreadcrumbMobileHomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;
`

export const BreadcrumbMobileHomeTitle = styled.div`
  font-weight: 900;
  ${Font16};
`

export const BreadcrumbMobileJobTitle = styled.div`
  font-weight: 325;
  color: ${theme.colors.moreGrey};
  ${Font14};
`

export const BreadcrumbBlock = styled.div`
  align-items: center;
  display: flex;
  ${Font14};
  font-weight: 600;
  &:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & + &:before {
    content: '/';
    margin: 0 16px;
  }
`

export const BreadcrumbHostIconWrapper = styled.div`
  margin: 0 8px 0 12px;
`

export const BreadcrumbStatusCircle = styled(Mark)`
  flex: none;
`

export const BreadcrumbIcon = styled(Icon)`
  margin-right: 10px;
`
